import { createFileRoute } from '@tanstack/react-router';
import { ReferralLanding } from '@/features/referrals';

export const Route = createFileRoute('/_authenticated/r/$code')({
    head: () => ({ meta: [{ title: 'You’re invited | promote.fun' }, { name: 'robots', content: 'noindex' }] }),
    component: ReferralLandingRoute,
});

function ReferralLandingRoute() {
    const { code } = Route.useParams();
    return <ReferralLanding code={code} />;
}
